import { documentServiceClient } from '../../api/client.ts';
import type { BlocksFromSectionsByDocumentIdApiResponse } from '../../documents/DocumentRepository.ts';
import {
  type Assigned,
  type AssignedSignedSignatureBox,
  type AssignedUnSignedSignatureBox,
  type BaseSignatureBox,
  type SignatureBox,
  type SignatureBoxApiResponse,
  SignatureStatus,
  type Signed,
  type UnAssignedSignedSignatureBox,
  type UnAssignedUnSignedSignatureBox,
} from 'services/entities/SignatureTypes';

export const transformSignatureBoxApiResponse = ({
  signature_box_id,
  type,
  properties,
  ...signatureBoxApi
}: SignatureBoxApiResponse): SignatureBox => {
  const base: BaseSignatureBox = {
    signatureBoxId: signature_box_id,
    properties,
    type,
  };

  if (signatureBoxApi.status === SignatureStatus.Signed) {
    const { signature_event } = signatureBoxApi;
    const { first_name, last_name, email, id, initials, ip_address, signed_date } = signature_event;
    const signed: Signed = {
      status: signatureBoxApi.status,
      signatureEvent: {
        id,
        email,
        initials,
        firstName: first_name,
        lastName: last_name,
        signedDate: signed_date,
        ipAddress: ip_address,
      },
    };

    if (signatureBoxApi.assigned_signee != null) {
      const { first_name, last_name, displayable_name, email, type, id } = signatureBoxApi.assigned_signee;
      const assigned: Assigned = {
        assignedSignee: { firstName: first_name, lastName: last_name, displayableName: displayable_name, email, type, id },
      };
      const assignedAndSignedSignatureBox: AssignedSignedSignatureBox = {
        ...base,
        ...signed,
        ...assigned,
      };
      return assignedAndSignedSignatureBox;
    }

    const unAssignedAndSignedSignatureBox: UnAssignedSignedSignatureBox = {
      ...base,
      ...signed,
      assignedSignee: signatureBoxApi.assigned_signee,
    };
    return unAssignedAndSignedSignatureBox;
  }

  if (signatureBoxApi.assigned_signee != null) {
    const { first_name, last_name, displayable_name, email, type, id } = signatureBoxApi.assigned_signee;
    const assigned: Assigned = {
      assignedSignee: { firstName: first_name, lastName: last_name, displayableName: displayable_name, email, type, id },
    };
    const assignedAndUnSigned: AssignedUnSignedSignatureBox = {
      ...base,
      ...assigned,
      status: signatureBoxApi.status,
      signatureEvent: signatureBoxApi.signature_event,
    };

    return assignedAndUnSigned;
  }

  const unAssignedAndUnsigned: UnAssignedUnSignedSignatureBox = {
    ...base,
    status: signatureBoxApi.status,
    assignedSignee: signatureBoxApi.assigned_signee,
    signatureEvent: signatureBoxApi.signature_event,
  };
  return unAssignedAndUnsigned;
};

// TODO: fix payload type, it's not the same as in the API schema
export type SignSignatureDocumentServiceApiPayload = {
  blockId: string;
  totalType: string;
  firstName: string;
  lastName: string;
  email: string;
  initials: string;
  updatedTables: BlocksFromSectionsByDocumentIdApiResponse[][] | undefined;
};

export class ApiSignatureDocumentServiceRepository {
  public async signSignature(
    contentId: string,
    payload: SignSignatureDocumentServiceApiPayload
  ): Promise<SignSignatureDocumentServiceApiPayload> {
    return await documentServiceClient.post(`document/${contentId}/sign`, payload);
  }
}
